<template>
  <div class="center-screen">
    <div class="container">
      <div class="auth-page register">
        <h1 v-if="!isMobile">{{ $store.getters['getClientMeta'].name }} Şimdi Katılın !</h1>
        <p v-if="!isMobile">Güvenilir ve Kazandıran casinonun adresi {{ $store.getters['getClientMeta'].name }}, zengin promosyon ve fırsatlarıyla sizi bekliyor!</p>
        <div class="form">
          <div class="row">
            <div class="col col-4" v-if="!isMobile">
              <img v-if="!_.isEmpty(banner)" :src="$store.state.main.cdn_url + banner.image">
            </div>
            <div class="col col-8">
              <div class="content">
                <h3 class="line-title">
                 {{ step == 1 ? 'Üyelik Oluştur ' : 'Son Adım' }}
                 
                  <svg v-if="!_.isEmpty(isAffiliate)" viewBox="0 0 24 24" version="1.2" baseProfile="tiny"><path d="M16.972 6.251c-.967-.538-2.185-.188-2.72.777l-3.713 6.682-2.125-2.125c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l4 4c.378.379.888.587 1.414.587l.277-.02c.621-.087 1.166-.46 1.471-1.009l5-9c.537-.966.189-2.183-.776-2.72z"/></svg>
                </h3>
                <form class="auth-content flex row-wrap" v-on:submit.prevent="firstRegister" v-if="step == 1">
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Adınız</label>
                        <input oninput="this.value = this.value.replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ\s]/g, '')" type="text" v-model="form.name" placeholder="Adınızı yazınız">
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Soyadınız</label>
                        <input oninput="this.value = this.value.replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ\s]/g, '')" type="text" v-model="form.surname" placeholder="Soyadınızı yazınız">
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Kullanıcı Adınız</label>
                        <input type="text" v-model="form.username" placeholder="Kullanıcı adınızı yazınız">
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>T.C Kimlik No</label>
                        <input :type="isMobile ? 'tel' : 'number'" v-model="form.identification_number" placeholder="TC Kimlik numaranızı yazınız">
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>E-Posta Adresıniz</label>
                        <input type="email" v-model="form.email" placeholder="E-Posta adresinizi yazınız">
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Şifreniz</label>
                        <input type="password" v-model="form.password" placeholder="Şifrenizi yazınız">
                      </div>
                  </div>
                  <div class="col col-3">
                      <div class="inline-form">
                        <label>Ülke</label>
                        <select v-model="form.country">
                          <option :value="null">Seçiniz</option>
                          <option v-for="(item,key) in countries" :key="key" :value="item.code">{{ item.name }}</option>
                        </select>
                      </div>
                  </div>
                  <div class="col col-3">
                      <div class="inline-form">
                        <label>Para Biriminiz</label>
                        <select v-model="form.currency">
                          <option :value="null">Seçiniz</option>
                          <option value="TRY">TRY</option>
                          <option value="USD">USD</option>
                          <option value="EUR">EUR</option>
                        </select>
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Telefon</label>
                        <vue-tel-input @input="onTelInput" v-bind="telProps"></vue-tel-input>
                      </div>
                  </div>
                  <div class="col col-6">
                      <div class="inline-form">
                        <label>Promosyon Kodu</label>
                        <input type="text" v-model="form.promotion_code" placeholder="Promosyon Kodu">
                      </div>
                  </div>
                  <div class="col col-6">
                      <ButtonLoader :style="isMobile ? '' : 'margin-top: 25px; width: 100%;'" class="primary" :loader="isLoading" :text="'Hesabımı Oluştur'">
                        <template name="icon">
                          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                      </ButtonLoader>
                  </div>
                    <div class="col justify-flex-end">
                      <p>Daha önce zaten kaydolunuz mu? <router-link to="/auth/login">Giriş yapın</router-link></p>
                    </div>
                </form>
                <form class="auth-content flex row-wrap" v-on:submit.prevent="register" v-if="step == 2">
                  <div class="col col-12">
                      <div class="inline-form">
                        <label>SMS Kodu</label>
                        <input :type="isMobile ? 'tel' : 'number'" v-model="form.sms_code" placeholder="SMS Kodu">
                      </div>
                  </div>
                  <div class="col justify-flex-end">
                      <ButtonLoader class="primary" :loader="isLoading" :text="'Kayıtı Tamamla'">
                        <template name="icon">
                          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                      </ButtonLoader>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  import { VueTelInput } from 'vue-tel-input'
  export default{
    name: 'Register',
    data(){
      return{
        smsRequire: false,
        isLoading: false,
        banner: [],
        step: 1,
        form:{
          sms_code:null,
          name:null,
          surname:null,
          username:null,
          identification_number:null,
          email:null,
          password:null,
          country: this.$i18n.locale.toUpperCase(),
          phone_number:null,
          promotion_code:null,
          phone_country:null,
          currency: this.$i18n.locale == 'tr' ? 'TRY' : null,
          'g-recaptcha-response': null
        },
        telProps:{
          defaultCountry: this.$i18n.locale,
          placeholder: "Telefon numaranızı yazınız",
          enabledFlags: true
        },
      }
    },
    methods:{
      ...mapActions("auth", ["login"]),

      firstRegister() {
        this.isLoading = true;
        this.$recaptchaLoaded().then(() => {
          this.$recaptcha('login').then((token) => {

            this.form['g-recaptcha-response'] = token;
            let affiliate = this.isAffiliate;
            let form = Object.assign({}, this.form);

            if(!_.isEmpty(affiliate)){
              Object.assign(form, affiliate);
              form.is_affiliate = 1;
            }
            if(this.smsRequire){
              axios.post('/auth/validation', { ...form })
              .then((response)=>{
                  if(response.data.status && response.data.send_sms){
                    this.step = 2
                  }
              })
              .catch(() => {})
              .finally(() => {
                this.isLoading = false;
              });
            }else{
              this.register();
            }
          })
        }).catch(() => {
          this.isLoading = false;
        })
      },

      register() {
        if(this.smsRequire){
          if(_.isNull(this.form.sms_code) || this.form.sms_code.length < 6){
            this.$store.dispatch('alert/message', { type: 'error', msg: 'Sms kodunu doğru bir biçimde giriniz' })
            return false
          }
        }
        let form = Object.assign({}, this.form);
        let affiliate = this.isAffiliate;
        if(!_.isEmpty(affiliate)){
          Object.assign(form, affiliate);
          form.is_affiliate = 1;
        }
        
        axios.post('/auth/register', { ...form })
        .then((response)=>{
          this.login(form);
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
      },
      onTelInput(formattedNumber, { number, country }) {
        this.form.phone_country = '+' + country.dialCode;
        this.form.phone_number = number.significant;
      },
      getBanner() {
          this.$store.dispatch('getBanner', ['register', 'both', 'left'])
          .then(response =>{
            this.banner   = !_.isUndefined(response.data['0']) ? response.data['0'] : [];
          });
      },
    },
    mounted(){
      this.getBanner();
    },
    components: {
      VueTelInput,
    },
    computed: {
      ...mapState("countries", ["countries"]),
      isAffiliate(){
        return this.$cookies.get(process.env.VUE_APP_AFFILIATE_COOKIE_TOKEN);
      }
    },
    watch:{
      'form.username' : function(v) {
          this.form.username = v.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '').toLowerCase().trim();
      },
      'form.email' : function(v) {
          this.form.email = v.toLowerCase().trim();
      },
    }
  }
</script>